import SwapDonorList from './components';
import Tabs from './components/nav';

interface IProps {
    activeKey: string,
    centerId: number,
    isAdmin: boolean
}

const Donors = (props: IProps) => {
    return (
        <>
            <Tabs
                tabKey={props.activeKey}
            />

            {props.activeKey == 'SWAP' && (
                <SwapDonorList
                    {...props}
                    centerId={props.centerId}
                    activeKey={props.activeKey}
                    isAdmin={props.isAdmin}
                />
            )}  
        </>
    );
}

export default Donors;